<section class="uw-page-container tw-px-2">
  <div class="uw-page-fold tw-flex tw-flex-col tw-bg-no-repeat tw-bg-top">
    <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-4 tw-m-auto ">
      <div class="tg-tagline">
        Transform Your
      </div>
      <div class="tg-tagline">
        Business With
      </div>
      <div class="tg-hero text-brand">
        {{brandName() || 'VOXR AI'}}
      </div>
      <div class="tg-title text-muted">
        Streamline Operations, Boost Revenue, Reduce Staffing & Training Costs!
      </div>
      <div>
        <a mat-fab extended routerLink="/login" class="tw-mt-4 btn-brand !tw-h-[initial]">
          <div class="tw-px-10 tg-section-title tw-py-5">Get Started Now</div>
        </a>
      </div>
    </div>
    <app-terms-links class="tw-mt-auto"></app-terms-links>
  </div>
</section>